import { setRequestStatus } from 'data-layer-cr/dist/network';
import { updateLastNetworkErrorMessage } from 'data-layer-cr/dist/network/networkStatusSlice';
import { AnyAction } from 'redux';
import {
  CreateAndUpdateDataPersonalAgentLinkResponse,
  CreateAndUpdatePersonalAgentLinkRequest,
  PersonalAgentLinkRequest,
  PersonalAgentLinkResponse,
} from 'src/models/responseTypes/PersonalAgentLink';
import NetworkClient from 'src/services/NetworkClient';
import processRequest from 'src/services/processRequest';
import { AsyncAppThunk, AsyncDispatch } from 'src/store/ThunkTypes';
import {
  CREATE_PERSONAL_AGENT_LINK,
  GET_PERSONAL_AGENT_LINK,
  UPDATE_PERSONAL_AGENT_LINK,
} from '../requestIdentifiers';
import { updatePersonalAgentLinkSlice } from '../slice/personalAgentLinkSlice';

export const getPersonalAgentLink =
  ({ agentCode, brokerLicense }: PersonalAgentLinkRequest): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(GET_PERSONAL_AGENT_LINK, 'requesting'));
    try {
      const response = await processRequest<PersonalAgentLinkResponse>({
        method: 'GET',
        url: `/PersonalAgentLinks/GetPersonalAgentLinksByLicenceAndCode?brokerLicense=${brokerLicense}&agentCode=${agentCode}`,
        client: NetworkClient,
      });
      dispatch(updatePersonalAgentLinkSlice(response.data.data));
      return dispatch(setRequestStatus(GET_PERSONAL_AGENT_LINK, 'success'));
    } catch (e) {
      dispatch(setRequestStatus(GET_PERSONAL_AGENT_LINK, 'failure'));
      return dispatch(updateLastNetworkErrorMessage(''));
    }
  };

export const createPersonalAgentLink =
  ({
    agentCode,
    brokerLicense,
    personalLink,
  }: CreateAndUpdatePersonalAgentLinkRequest): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(CREATE_PERSONAL_AGENT_LINK, 'requesting'));
    try {
      const response =
        await processRequest<CreateAndUpdateDataPersonalAgentLinkResponse>({
          method: 'POST',
          url: `/PersonalAgentLinks/SaveAgentPersonalLink`,
          client: NetworkClient,
          data: {
            agentCode,
            brokerLicense,
            personalLink,
          },
        });
      dispatch(updatePersonalAgentLinkSlice(response.data?.data.data));
      return dispatch(setRequestStatus(CREATE_PERSONAL_AGENT_LINK, 'success'));
    } catch (e) {
      dispatch(setRequestStatus(CREATE_PERSONAL_AGENT_LINK, 'failure'));
      return dispatch(updateLastNetworkErrorMessage(''));
    }
  };

export const updatePersonalAgentLink =
  ({
    agentCode,
    brokerLicense,
    personalLink,
  }: CreateAndUpdatePersonalAgentLinkRequest): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(UPDATE_PERSONAL_AGENT_LINK, 'requesting'));
    try {
      const response =
        await processRequest<CreateAndUpdateDataPersonalAgentLinkResponse>({
          method: 'POST',
          url: `/PersonalAgentLinks/UpdateAgentPersonalLink`,
          client: NetworkClient,
          data: {
            agentCode,
            brokerLicense,
            personalLink,
          },
        });
      dispatch(updatePersonalAgentLinkSlice(response.data?.data.data));
      return dispatch(setRequestStatus(UPDATE_PERSONAL_AGENT_LINK, 'success'));
    } catch (e) {
      dispatch(setRequestStatus(UPDATE_PERSONAL_AGENT_LINK, 'failure'));
      return dispatch(updateLastNetworkErrorMessage(''));
    }
  };
